(function () {
  'use strict';

  angular.module('app').component('packageCostDetail', packageCostDetail());

  function packageCostDetail() {
    return {
      bindings: {
        packageCosts: '=',
        package: '<',
        paxRanges: '<',
        seasonSelected: '<',
        priceListSelected: '<',
        provider: '<',
        onPackageCostsSaved: '&',
        onPackageCostsCanceled: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: PackageCostDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/package-costs/package-cost-detail/package-cost-detail.component.html',
    };
  }

  PackageCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'PackageCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function PackageCostDetailComponent(config, UtilService, PackageCostService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.selectPaxRange = selectPaxRange;
    vm.openSuggestedPackageCosts = openSuggestedPackageCosts;

    vm.savePackageCosts = savePackageCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.packageCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.packageCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.packageCosts.forEach(function (packageCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && packageCost.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Set all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.schedules = [];
        paxRange.schedules.push(setPaxRangeCosts(paxRange));

        vm.paxRangesData.push(paxRange);
      });
    }

    function setPaxRangeCosts(paxRange) {
      var packageCostId;
      var adultCost = '',
        childCost = 0,
        infantCost = 0,
        seniorCost = 0;

      var packageCost;

      // Exist package costs
      if (vm.packageCosts.length > 0) {
        for (var i = 0; i < vm.packageCosts.length; i++) {
          packageCost = vm.packageCosts[i];

          if (packageCost.pax_range_id === paxRange.id) {
            packageCostId = packageCost.id;

            adultCost = packageCost.adult_cost;
            childCost = packageCost.child_cost;
            infantCost = packageCost.infant_cost;
            seniorCost = packageCost.senior_cost;
            break;
          }
        }
      }

      var schedule = {
        adult_cost: adultCost,
        child_cost: childCost,
        infant_cost: infantCost,
        senior_cost: seniorCost,
        packageCostId: null,
      };

      if (packageCostId) {
        schedule.packageCostId = packageCost.id;
      }

      return schedule;
    }

    function openSuggestedPackageCosts() {
      // var successCallback = function(){
      //     console.log('successCallback');
      // };

      var data = {
        package: vm.package,
        season: vm.seasonSelected,
        priceList: vm.priceListSelected,
        provider: vm.provider,
        paxRange: vm.paxRangesSelected[0],
      };

      // console.log(data);

      PackageCostService.openSuggestedPackageCostsModal(data, {});
    }

    function savePackageCosts(isFormValid) {
      if (!isFormValid) {
        return;
      }

      var packageCosts = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.schedules.forEach(function (schedule) {
              var cost = {
                adult_cost: schedule.adult_cost || 0,
                child_cost: schedule.child_cost || 0,
                infant_cost: schedule.infant_cost || 0,
                senior_cost: schedule.senior_cost || 0,

                pax_range_id: paxRangeSelected.id,
                id: null,
              };

              if (schedule.packageCostId) {
                cost.id = schedule.packageCostId;
              }

              packageCosts.push(cost);
            });

            break; // check
          }
        }
      }

      let params = {
        package_costs: packageCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
        get_associated_providers: null,
      };

      if (vm.getAssociatedProvidersOnSave) {
        params.get_associated_providers = true;
      }

      // console.log(params); return;

      vm.sendingForm = true;
      PackageCostService.savePackageCosts(vm.package, params, vm.editMode).then(function (data) {
        if (data) {
          // console.log('1 - PackageCostDetailComponent');

          let obj = vm.getAssociatedProvidersOnSave ? { dataObj: data.associated_providers } : {};

          vm.onPackageCostsSaved(obj);

          setItemOptions(data.package_costs[0].updated_at);

          vm.packageCosts = data.package_costs;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onPackageCostsCanceled();
    }
  }
})();
